/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionAuditActorOptionData
 */
export interface SubscriptionAuditActorOptionData {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditActorOptionData
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditActorOptionData
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditActorOptionData
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditActorOptionData
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditActorOptionData
     */
    email?: string | null;
}

/**
 * Check if a given object implements the SubscriptionAuditActorOptionData interface.
 */
export function instanceOfSubscriptionAuditActorOptionData(value: object): value is SubscriptionAuditActorOptionData {
    return true;
}

export function SubscriptionAuditActorOptionDataFromJSON(json: any): SubscriptionAuditActorOptionData {
    return SubscriptionAuditActorOptionDataFromJSONTyped(json, false);
}

export function SubscriptionAuditActorOptionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionAuditActorOptionData {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
    };
}

export function SubscriptionAuditActorOptionDataToJSON(json: any): SubscriptionAuditActorOptionData {
    return SubscriptionAuditActorOptionDataToJSONTyped(json, false);
}

export function SubscriptionAuditActorOptionDataToJSONTyped(value?: SubscriptionAuditActorOptionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'userId': value['userId'],
        'name': value['name'],
        'phone': value['phone'],
        'email': value['email'],
    };
}

